import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import {
  Modal,
  Table,
  Button,
  Input,
  Form,
  Col,
  Space,
} from "antd";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import {
  LeftOutlined,
  RightOutlined,
  CheckOutlined,
  CloseOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import newDateTime from "controllers/newDateTime";

const backend = process.env.REACT_APP_BACKEND;
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;

function AbbreviatedWords() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sourceDataKor, setSourceDataKor] = useState([]);
  const [rowIndex, setRowIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reRender, setReRender] = useState(false);
  const [insertPopup, setInsertPopup] = useState(false);
  const [editPopup, setEditPopup] = useState([false, {}]);
  const [preNext, setPreNext] = useState([false, false]);
  const formRef = useRef(null);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSizeOptions: [10, 50, 100, 200],
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSize: 10, // 한 페이지에 표시할 레코드 수
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
    },
    filters: {
      searchFilter: "",
    },
  });

  const columns = [
    {
      title: "NO",
      dataIndex: "rowKey",
      key: "rowKey",
      width: "100px",
    },
    {
      title: "정식 표현",
      dataIndex: "words",
      key: "words",
      width: "300px",
    },
    {
      title: "축약 표현",
      dataIndex: "contractions",
      key: "contractions",
      width: "300px",
    },
    {
      title: "처리",
      dataIndex: "",
      width:"150px",
      render: (_, record) => (
        <div>
          <a
            style={{ margin: "0px 5px" }}
            onClick={(e) => {
              e.stopPropagation();
              const rowIdx = record.num
              const maxNum = tableParams.pagination.total - 1;
              const plusNum =
                (tableParams.pagination.current - 1) *
                tableParams.pagination.pageSize;
              const idx = plusNum + rowIdx;
              // if (rightBox[0]) {
              //   setRightBox([false, {}]);
              // }
              if (sourceDataKor.length === 1 && tableParams.pagination.total === 1) {
                setPreNext([true, true]);
              } else if (idx === 0) {
                setPreNext([true, false]);
              } else if (idx === maxNum) {
                setPreNext([false, true]);
              } else {
                setPreNext([false, false]);
              }
              setRowIndex(rowIdx);
              setEditPopup([true,record])

              // if (sourceDataKor.length === 1) {
              //   setPreNext([true, true]);
              // } else if (_.num === 0) {
              //   setPreNext([true, false]);
              // } else if (_.num === sourceDataKor.length - 1) {
              //   setPreNext([false, true]);
              // }
              // setRowIndex(_.num - plusNum);
              // setEditPopup([true, _]); // reset해도 값을 유지하기 위함
            }}
          >
            수정
          </a>
          <a
            style={{ margin: "0px 5px" }}
            onClick={(e) => {
              e.stopPropagation();
              deleteHandler(_);
            }}
          >
            삭제
          </a>
        </div>
      ),
    },
    {}
  ];

  const getSourceData = (data) => {
    // console.log(data)
    const total = data.data.data[1][0]["FOUND_ROWS()"];
    const page = tableParams.pagination.current;
    const size = tableParams.pagination.pageSize;
    const plusNum = (page - 1) * size;
    const sourceData = data.data.data[0].map((el, idx) => {
      const rowKey = total - idx - plusNum;
      // el.create_datetime = newDateTime(el.create_datetime)
      el.rowKey = rowKey;
      el.num = idx;
      return el;
    });
    // console.log(sourceData);

    setSourceDataKor(sourceData);
    if(editPopup[0] && (rowIndex === 0 || rowIndex === size-1)) {
      setEditPopup([true,sourceData[rowIndex]])
      formRef.current.setFieldsValue(sourceData[rowIndex])
    }

    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: total, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
      },
    });
  };

  const onSearch = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: { ...tableParams.filters, searchFilter: value },
    });
  }

  const insertOkHandler = async () => {
    const value = await formRef.current.validateFields();

    axios
      .post(`${backend}/contents/contractions/insert`, { value })
      .then((data) => {
        setReRender(!reRender);
        Modal.success({
          title: "등록 완료",
          okText: "확인",
          content: "정상적으로 등록되었습니다.",
          afterClose: () => {
            setInsertPopup(false);
          },
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        } else {
          console.log(err);
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:err.response.data.message ||
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        }
      });
  };

  const insertOkNextHandler = async () => {
    const value = await formRef.current.validateFields();

    axios
      .post(`${backend}/contents/contractions/insert`, { value })
      .then((data) => {
        formRef.current.resetFields();
        setReRender(!reRender);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        } else {
          console.log(err);
          Modal.error({
            title: "등록 실패",
            style: { whiteSpace: "pre-line" },
            okText: "확인",
            content:err.response.data.message ||
              "정상적으로 등록되지 않았습니다. \n다시 시도하거나 관리자에게 문의해주세요.",
          });
        }
      });
  };

  const deleteHandler = (_) => {
    const id = _.id;

    axios
      .post(`${backend}/contents/contractions/delete`, { id })
      .then((data) => {
        setReRender(!reRender);
        setRowIndex(null)
        Modal.success({
          title: "삭제완료",
          content: "정상적으로 삭제되었습니다.",
          okText: "확인",
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        } else {
          console.log(err);
          Modal.error({
            title: "삭제 실피",
            okText: "확인",
            content:
              "정상적으로 삭제되지 않았습니다. 다시 시도하거나 관리자에게 문의해주세요.",
          });
        }
      });
  };

  const editOkHandler = async () => {
    const value = await formRef.current.validateFields();
    axios
      .post(`${backend}/contents/contractions/edit`, { value })
      .then((data) => {
        setReRender(!reRender)
        Modal.success({
          title: "수정 완료",
          okText: "확인",
          content: "정상적으로 수정되었습니다.",
        });
      })
      .catch((err) => {
        console.log(err);
        Modal.error({
          title: "수정 실피",
          okText: "확인",
          content:
            "정상적으로 수정되지 않았습니다. 다시 시도하거나 관리자에게 문의해주세요.",
        });
      });
  };

  const preRecord = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const preNum = nowNum - 1;
    const newPage = parseInt(preNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === max && preNum !== 0) {
      setPreNext([false, false]);
    }
    if (preNum === 0) {
      setPreNext([true, false]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(preNum - plusNum);
    // console.log(rowIndex)
    // console.log(preNum,plusNum)
    if (rowIndex === 0) {
      formRef.current.setFieldValue("num", preNum - plusNum);
    } else {
      setEditPopup([true, data[preNum - plusNum]]);
      formRef.current.resetFields();
      formRef.current.setFieldsValue(data[preNum - plusNum]);
    }

  }

  const nextRecord = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const nextNum = nowNum + 1;
    const newPage = parseInt(nextNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === 0 && nextNum !== max) {
      setPreNext([false, false]);
    }
    if (nextNum === max) {
      setPreNext([false, true]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(nextNum - plusNum);

    if (nextNum - plusNum === 0) {
      formRef.current.setFieldValue("num", nextNum - plusNum);
    } else {
      setEditPopup([true, data[nextNum - plusNum]]);
      formRef.current.resetFields();
      formRef.current.setFieldsValue(data[nextNum - plusNum]);
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      ...tableParams,
      pagination,
    });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setSourceDataKor([]);
    }
  };

  useEffect(() => {
    setLoading(true);
    const { current, pageSize } = tableParams.pagination;
    // console.log(tableParams)
    axios
      .post(
        `${backend}/contents/contractions/read?current=${current}&pageSize=${pageSize}`,
        { filter: tableParams.filters }
      )
      .then((data) => {
        // console.log(data);
        getSourceData(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          dispatch(authAction(false, null));
        }
      });
  }, 
  [
    JSON.stringify(tableParams.filters),
    JSON.stringify(tableParams.pagination.current),
    JSON.stringify(tableParams.pagination.pageSize),
    reRender
  ]);

  return (
    <div style={{ display: "flex", flexDirection:"column", height:"100%", overflow: "auto" }}>
      <Modal
        destroyOnClose={true}
        open={insertPopup}
        title="축약형 단어 등록"
        maskClosable={false}
        onCancel={() => setInsertPopup(false)}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                formRef.current.resetFields();
              }}
            >
              내용 초기화
            </Button>
            <span>
              <Button
                type="primary"
                onClick={insertOkHandler}
                icon={<CheckOutlined />}
              >
                등록
              </Button>
              <Button onClick={insertOkNextHandler} icon={<CheckOutlined />}>
                등록 후 계속
              </Button>
              <Button
                onClick={() => setInsertPopup(false)}
                icon={<CloseOutlined />}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Form ref={formRef} layout="vertical">
          <Form.Item
            name="words"
            label="정식 표현"
            required={true}
            rules={[{ required: true, message: "정식 표현은 필수값입니다." }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="contractions"
            label="축약 표현"
            required={true}
            rules={[{ required: true, message: "정식 표현은 필수값입니다." }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        destroyOnClose={true}
        open={editPopup[0]}
        title="축약형 단어 수정"
        maskClosable={false}
        onCancel={() => {setEditPopup([false, {}]);setRowIndex(null)}}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                formRef.current.resetFields();
              }}
            >
              내용 초기화
            </Button>
            <span>
              <Button
                onClick={preRecord}
                disabled={preNext[0]}
                icon={<LeftOutlined />}
              >
                이전
              </Button>
              <Button
                type="primary"
                onClick={editOkHandler}
                icon={<CheckOutlined />}
              >
                수정
              </Button>
              <Button
                onClick={nextRecord}
                disabled={preNext[1]}
                icon={<RightOutlined />}
              >
                다음
              </Button>
              <Button
                onClick={() => {setEditPopup([false, {}]);setRowIndex(null)}}
                icon={<CloseOutlined />}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Form ref={formRef} layout="vertical" initialValues={editPopup[1]}>
          <Form.Item
            name="id"
            hidden = {true}
          >
            <Input/>
          </Form.Item>
          <Form.Item
            name="words"
            label="정식 표현"
            required={true}
            rules={[{ required: true, message: "정식 표현은 필수값입니다." }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="contractions"
            label="축약 표현"
            required={true}
            rules={[{ required: true, message: "정식 표현은 필수값입니다." }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span style={{ minWidth: "100px", textAlign: "left" }}>
          축약형 단어 목록
        </span>
        <Space wrap>
        <Input.Search
            placeholder="영어 단어를 입력하세요."
            onSearch={onSearch}
            allowClear={true}
            style={{
              width: 250,
              marginLeft: "5px",
            }}
          />
          <Button onClick={() => setInsertPopup([true, {}])}>
            <PlusOutlined />
            축약형 단어 등록
          </Button>
        </Space>
      </div>

      <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
        <Col flex={1} style={{ minWidth: "100px" }}>
          <StyledTable
            className="pageTable"
            rowClassName={(record, index) => {
              return index === rowIndex ? "selectedRow" : "";
            }}
            columns={columns}
            rowKey="id"
            dataSource={sourceDataKor}
            loading={loading}
            pagination={tableParams.pagination}
            onChange={handleTableChange}
            scroll={{ x:100, y:"100%"}}
          />
        </Col>
      </div>
    </div>
  );
}

export default AbbreviatedWords;
